import { presetPrimaryColors } from '@ant-design/colors';
import devWarning from '../vc-util/devWarning';
export function validProgress(progress) {
    if (!progress || progress < 0) {
        return 0;
    }
    if (progress > 100) {
        return 100;
    }
    return progress;
}
export function getSuccessPercent({ success, successPercent }) {
    let percent = successPercent;
    /** @deprecated Use `percent` instead */
    if (success && 'progress' in success) {
        devWarning(false, 'Progress', '`success.progress` is deprecated. Please use `success.percent` instead.');
        percent = success.progress;
    }
    if (success && 'percent' in success) {
        percent = success.percent;
    }
    return percent;
}
export function getPercentage({ percent, success, successPercent }) {
    const realSuccessPercent = validProgress(getSuccessPercent({ success, successPercent }));
    return [realSuccessPercent, validProgress(validProgress(percent) - realSuccessPercent)];
}
export function getStrokeColor({ success = {}, strokeColor, }) {
    const { strokeColor: successColor } = success;
    return [successColor || presetPrimaryColors.green, strokeColor || null];
}
function toWidthHeight(size, defaultWidth, defaultHeight) {
    var _a, _b, _c, _d;
    if (Array.isArray(size)) {
        return [(_a = size[0]) !== null && _a !== void 0 ? _a : defaultWidth, (_b = size[1]) !== null && _b !== void 0 ? _b : defaultHeight];
    }
    return [(_c = size.width) !== null && _c !== void 0 ? _c : defaultWidth, (_d = size.height) !== null && _d !== void 0 ? _d : defaultHeight];
}
export const getSize = (size, type, extra) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let width = -1;
    let height = -1;
    if (type === 'step') {
        const steps = extra.steps;
        const strokeWidth = extra.strokeWidth;
        if (typeof size === 'string' || typeof size === 'undefined') {
            width = size === 'small' ? 2 : 14;
            height = strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : 8;
        }
        else if (typeof size === 'number') {
            [width, height] = [size, size];
        }
        else {
            [width, height] = toWidthHeight(size, 14, 8);
        }
        width *= steps;
    }
    else if (type === 'line') {
        const strokeWidth = extra === null || extra === void 0 ? void 0 : extra.strokeWidth;
        if (typeof size === 'string' || typeof size === 'undefined') {
            height = strokeWidth || (size === 'small' ? 6 : 8);
        }
        else if (typeof size === 'number') {
            [width, height] = [size, size];
        }
        else {
            [width, height] = toWidthHeight(size, -1, 8);
        }
    }
    else if (type === 'circle' || type === 'dashboard') {
        if (typeof size === 'string' || typeof size === 'undefined') {
            [width, height] = size === 'small' ? [60, 60] : [120, 120];
        }
        else if (typeof size === 'number') {
            [width, height] = [size, size];
        }
        else if (Array.isArray(size)) {
            if (process.env.NODE_ENV !== 'production') {
                devWarning(false, 'Progress', 'Type "circle" and "dashboard" do not accept array as `size`, please use number or preset size instead.');
            }
            width = (_b = (_a = size[0]) !== null && _a !== void 0 ? _a : size[1]) !== null && _b !== void 0 ? _b : 120;
            height = (_d = (_c = size[0]) !== null && _c !== void 0 ? _c : size[1]) !== null && _d !== void 0 ? _d : 120;
        }
        else if (size && typeof size === 'object') {
            if (process.env.NODE_ENV !== 'production') {
                devWarning(false, 'Progress', 'Type "circle" and "dashboard" do not accept object as `size`, please use number or preset size instead.');
            }
            width = (_f = (_e = size.width) !== null && _e !== void 0 ? _e : size.height) !== null && _f !== void 0 ? _f : 120;
            height = (_h = (_g = size.width) !== null && _g !== void 0 ? _g : size.height) !== null && _h !== void 0 ? _h : 120;
        }
    }
    return { width, height };
};
